import React = require('react');

interface IReferAFriendBanner {
  content: JSX.Element,
  buttonText: string,
  buttonUrl: string,
  style?: object,
}

export const ReferAFriendBanner = ({content, buttonText, buttonUrl, style}: IReferAFriendBanner) => {
  return (
    <div className={'refer-a-friend-banner'} style={style}>
      <div className={'refer-a-friend-banner--image-wrapper'}>
        <img src={require('./images/refer_a_friend.png')} alt="Refer a Friend"/>
      </div>
      <div className={'refer-a-friend-banner--content'}>
        <div className={'refer-a-friend-banner--content-text'}>{content}</div>
        <a href={buttonUrl} className={'refer-a-friend-banner--content-button pill-button'} target={'_blank'}>{buttonText}</a>
      </div>
    </div>
  )
}
